// Baked-in defaults so a site needs nothing but the <script> tag.
//
// The HubID keys live here because this SDK runs in the browser and these are
// HubID's browser-safe keys (they are visible in DevTools on every site that
// loads this file). Never put a genuinely secret key here.
export const BAKED = {
  baseUrl: 'https://id.hubculture.com',
  publicKey: 'public_153222247f4cbe2511208120a',
  privateKey: 'private_5d265de1d9204f6235830ce2',

  // Where to hand the verified token so the *site* can start its own session.
  // Set data-session-endpoint="none" on the script tag for static sites that
  // have no backend session (the token is then only kept client-side).
  sessionEndpoint: '/hubLoginSession',

  // Where to send the user after a successful login. Default is the site home.
  // Set to 'none' to stay on the current page (e.g. a JS app that re-renders).
  redirect: '/',

  selector: '.hub-login-btn, [data-hub-login]',

  // Clicking any of these clears the stored HubID token, so the site's own
  // logout link doesn't leave a stale token behind. Navigation is not blocked.
  logoutSelector: '#logout, .hub-logout-btn, [data-hub-logout]',

  // --- Hub ecosystem compatibility -------------------------------------
  // Existing Hub code reads the token/profile from these well-known places:
  //   • Ven's Vue app  -> localStorage['hubid-api-clients']  (store KEY_TOKEN)
  //   • chat widget    -> localStorage['hubid-api-clients'], falling back to
  //                       the 'hubid-api-client' cookie, plus
  //                       localStorage['hubUserData'] and the
  //                       'hubculturecom' cookie
  // Writing them keeps that code working. Set legacyTokenKey/legacyUserKey to
  // null to opt out on a site that doesn't need them.
  legacyTokenKey: 'hubid-api-clients',
  legacyUserKey: 'hubUserData',
  legacyUserCookie: 'hubculturecom',
  // Appended as "<userId>-<suffix>" in the cookie above; per-site, e.g. VENVC.
  legacyCookieSuffix: null,
};

// Reads overrides off the <script> tag, e.g.
//   <script src="…/hub-login.js"
//           data-session-endpoint="/my-login"
//           data-title="Sign in to Ven"
//           data-primary-color="#42b479"></script>
export function readScriptConfig(scriptEl) {
  if (!scriptEl || !scriptEl.dataset) return {};
  const d = scriptEl.dataset;
  const cfg = {};
  const theme = {};

  // !== undefined, not truthiness: data-base-url="" is a valid value meaning
  // "same origin as the page".
  if (d.baseUrl !== undefined) cfg.baseUrl = d.baseUrl;
  if (d.publicKey) cfg.publicKey = d.publicKey;
  if (d.privateKey) cfg.privateKey = d.privateKey;
  if (d.sessionEndpoint) cfg.sessionEndpoint = d.sessionEndpoint;
  if (d.clientId) cfg.clientId = d.clientId;
  if (d.selector) cfg.selector = d.selector;
  if (d.redirect) cfg.redirect = d.redirect;
  if (d.autoInit === 'false') cfg.autoInit = false;
  if (d.legacyCookieSuffix) cfg.legacyCookieSuffix = d.legacyCookieSuffix;
  if (d.legacyCompat === 'false') {
    cfg.legacyTokenKey = null;
    cfg.legacyUserKey = null;
    cfg.legacyUserCookie = null;
  }

  if (d.title) theme.title = d.title;
  if (d.subtitle) theme.subtitle = d.subtitle;
  if (d.logo) theme.logo = d.logo;
  if (d.primaryColor) theme.primaryColor = d.primaryColor;
  if (d.primaryColorHover) theme.primaryColorHover = d.primaryColorHover;
  if (d.accentColor) theme.accentColor = d.accentColor;
  if (Object.keys(theme).length) cfg.theme = theme;

  return cfg;
}

// Locates this script tag so its data-* attributes can be read.
export function findOwnScript() {
  if (document.currentScript) return document.currentScript;
  const guesses = document.querySelectorAll('script[src*="hub-login"]');
  return guesses.length ? guesses[guesses.length - 1] : null;
}
